// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tabStyle_tabRow__bOWQl {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}
.tabStyle_tabRow__bOWQl .tabStyle_tabBtns__6y6ZM {
  display: flex;
  gap: 12px;
  align-items: center;
  flex: 1 1;
}
.tabStyle_tabRow__bOWQl .tabStyle_tabBtns__6y6ZM .tabStyle_tabItem__6d2aS {
  display: flex;
  align-items: center;
  gap: 8px;
  text-align: left;
}
.tabStyle_tabRow__bOWQl .tabStyle_tabBtns__6y6ZM .tabStyle_tabItem__6d2aS img,
.tabStyle_tabRow__bOWQl .tabStyle_tabBtns__6y6ZM .tabStyle_tabItem__6d2aS svg {
  width: 16px;
  height: 16px;
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/components/atoms/tab/tabStyle.module.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;AACD;AACC;EACC,aAAA;EACA,SAAA;EACA,mBAAA;EACA,SAAA;AACF;AACE;EACC,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;AACH;AACG;;EAEC,WAAA;EACA,YAAA;EACA,cAAA;AACJ","sourcesContent":[".tabRow {\r\n\tdisplay: flex;\r\n\tjustify-content: space-between;\r\n\talign-items: center;\r\n\tflex-wrap: wrap;\r\n\tgap: 10px;\r\n\r\n\t.tabBtns {\r\n\t\tdisplay: flex;\r\n\t\tgap: 12px;\r\n\t\talign-items: center;\r\n\t\tflex: 1;\r\n\r\n\t\t.tabItem {\r\n\t\t\tdisplay: flex;\r\n\t\t\talign-items: center;\r\n\t\t\tgap: 8px;\r\n\t\t\ttext-align: left;\r\n\r\n\t\t\timg,\r\n\t\t\tsvg {\r\n\t\t\t\twidth: 16px;\r\n\t\t\t\theight: 16px;\r\n\t\t\t\tdisplay: block;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabRow": `tabStyle_tabRow__bOWQl`,
	"tabBtns": `tabStyle_tabBtns__6y6ZM`,
	"tabItem": `tabStyle_tabItem__6d2aS`
};
export default ___CSS_LOADER_EXPORT___;
